<script setup lang="ts">
import { useAsyncData, useNuxtApp } from "#app";
import { setMeta } from "~/utils/meta";
import { useBlogCollectionStore } from "~/stores/blog/blogCollection";
import { computed } from "vue";
import { useRoute } from "vue-router";

definePageMeta({
    alias: '/blog/page/:page',
});

const blogCollectionStore = useBlogCollectionStore();
const page = useRoute()?.params?.page !== undefined ? Number(useRoute()?.params.page) : 1;

useAsyncData('blogCollection', async () => await blogCollectionStore.fetchList(page));
const {data} = await useAsyncData('meta', async () => {
    const response = await useNuxtApp().axios.get('/blog-page?populate[seo][populate][]=metaImage');
    return response?.data.data;
});
if (data.value?.attributes !== undefined) {
    setMeta(data.value?.attributes.seo);
}

const posts = computed(() => blogCollectionStore.list);
const postsError = computed(() => blogCollectionStore.error);
const pagination = computed(() => blogCollectionStore.pagination);
</script>

<template>
    <div class="container space-y-16 text-black dark:text-white blog">
        <div class="space-y-2">
            <h1 class="text-3xl font-bold tracking-tight sm:text-4xl">Blog</h1>
            <p class="code-block">
                fetch("/posts")
            </p>
        </div>

        <ul v-if="posts !== undefined && posts.length" class="grid grid-cols-1 gap-16 md:grid-cols-2 lg:grid-cols-3">
            <li v-for="post in posts" class="space-y-3">
                <nuxt-link :to="post.url" class="block w-full text-left">
                    <img class="block image mb-4 h-[200]" :src="post.previewImage" :alt="post.title" height="200" />
                    <h2 class="text-xl font-bold mb-4">{{ post.title }}</h2>
                    <div class="mb-4"><p>{{ post.previewText }}</p></div>
                    <p v-if="post.tags" class="block code-block">// {{ post.tags }}</p>
                </nuxt-link>
            </li>
        </ul>

        <pre v-if="postsError !== undefined && postsError" class="code-block mt-8">
showError("<span class="text-red-500">{{ postsError }}</span>")
</pre>

        <div v-if="pagination !== undefined && pagination.pageCount > 1" class="code-block">
            const pagination = [
            <template v-for="index in pagination.pageCount">
                <nuxt-link v-if="index === 1" to="/blog" class="button button-code">{{ index }}</nuxt-link>
                <nuxt-link v-else :to="`/blog/page/${index}`" class="button button-code">{{ index }}</nuxt-link>
                <span v-if="index < pagination.pageCount">, </span>
            </template>
            ]
        </div>
    </div>
</template>

<style lang="scss">
.blog {
    .image {
        object-fit: cover;
        width: 100%;
        height: 200px;
    }
}
</style>